/* eslint-disable eqeqeq */
/*Fil med stöd funktioner för att hantera olika operationer som är återkommande*/

import { Customer } from "../../services/API/Customer";
import { Invoice } from "../../services/API/Invoices"
import { /*ConfirmButtonActions,*/ InternalInvoiceWithCsrdAndGroupId, InvoiceKey, InvoicesWithCsrdAndGroupId, MovedDateInvoice, ReportedPeriodReportType, StandardInvoiceReport } from "./editTypes"
import { Option } from 'react-bootstrap-typeahead/types/types';
import { Contract } from '../../services/API/Contracts';


type groupKey = keyof Pick<InvoicesWithCsrdAndGroupId,'rowSumExclMoms'>;
type invoiceKey = keyof Pick<Invoice,'priceExcMoms'> ;
type uninOfKeys = groupKey | invoiceKey;

const editUtils = {
    /**
 * Calculates the total sum for a specific set of invoices or groups based on the given report data and price property.
 * 
 * @param {StandardInvoiceReport} report - The report containing the invoices or groups to sum.
 * @param {keyof InvoiceKey} path - The path in the report where the data resides (either 'invoices' or 'csrdGroup').
 * @param {uninOfKeys} priceProp - The property of the invoice or group to sum, such as 'priceExcMoms' or 'rowSumExclMoms'.
 * @returns {number} - The calculated sum of all the relevant invoices or groups.
 * 
 * @remarks
 * - If `path` is 'invoices', it sums the property of each invoice in the list.
 * - If `path` is 'csrdGroup', it sums the property of each group in the list.
 * - Returns 0 if the path doesn't match or if there are no invoices/groups to process.
 */
    CalculateNewSumTotal:(report:StandardInvoiceReport,path:keyof InvoiceKey,priceProp:uninOfKeys) => {
        if(path in report.report ){
            const buff:StandardInvoiceReport = structuredClone(report) 
            if(path == 'invoices'){
                const arr:Invoice[] = structuredClone(buff.report[path]) as Invoice[]
                if(Array.isArray(arr)){
                    const accumulatedSumOfAllInvoices = arr?.reduce((acc:number,curr:Invoice ) => {
                        if(priceProp == 'priceExcMoms'){
                         return acc + curr[priceProp]
                        }
                        return acc
                       },0)
                       return accumulatedSumOfAllInvoices as number 
                }
            }
            else if(path == 'csrdGroup'){
                const arr:InvoicesWithCsrdAndGroupId[] = structuredClone(buff.report[path]) as InvoicesWithCsrdAndGroupId[]
                const accumulatedSumOfAllInvoices = arr?.reduce((acc:number,curr: InvoicesWithCsrdAndGroupId) => {
                    
                    if(priceProp == 'rowSumExclMoms' && typeof curr[priceProp] !== 'undefined'){
                     
                     return acc + curr[priceProp]   
                    }
                    return acc
                   },0)
                   return accumulatedSumOfAllInvoices as number ?? 0
            }
        }
        return 0
        
    },
    /**
 * Updates a customer or contract information in the provided item based on the report type and key.
 * 
 * @param {keyof InvoiceKey} invoiceKey - The type of the invoice key (e.g., 'invoices').
 * @param {keyof T} key - The key of the item to update (e.g., 'contractId', 'customerOrgId', etc.).
 * @param {T} item - The item that contains the data to be updated.
 * @param {Customer[]} customers - The list of customers to search through.
 * @param {Contract[]} contracts - The list of contracts to search through.
 * @param {Option[]} e - The options selected by the user.
 * @returns {T | undefined} - The updated item or `undefined` if no update was necessary.
 * 
 * @remarks
 * - If the key is related to customer information, it will update `customerName` and `customerOrgId` based on the selected option.
 * - If the key is 'contractId', it updates the contract information.
 */
    UpdateCustomerBasedOnReportType:<T extends object>(invoiceKey:keyof InvoiceKey,key:keyof T,item:T,customers:Customer[],contracts:Contract[],e:Option[]):T | undefined => {
        const buff:T =  structuredClone(item)
        if(/*invoiceKey == 'invoices' &&*/ key !== 'contractId' && 'customerOrgId' in buff && 'customerName' in buff ){
            const customer =  customers.find(x => x.kndNamn== e[0] || x.kndOrgnr.toString() == e[0])
            buff['customerName'] = customer?.kndNamn == undefined ? '':customer.kndNamn
            buff['customerOrgId'] = customer?.kndOrgnr == undefined ? '':customer.kndOrgnr
            return buff
          }else if(/*invoiceKey == 'invoices' &&*/ key == 'contractId' && 'contractId' in buff ){
            const contract =  contracts.find(x => x.contractId == e[0])
            buff['contractId'] = contract?.contractId == undefined ? '' : contract.contractId
            //this.props.callBack(buff,index)
            return buff
          }
    },
    /**
 * Updates the main invoice details when changes occur on the CSRD article rows.
 * 
 * @param {StandardInvoiceReport} report - The report containing the main invoice and CSRD data.
 * @param {InternalInvoiceWithCsrdAndGroupId} csrdRow - The CSRD row data that caused the change.
 * @param {Customer[]} customers - The list of customers used to fetch customer-specific information.
 * @returns {StandardInvoiceReport} - The updated report with the modified invoice details.
 * 
 * @remarks
 * - This function matches and updates the relevant invoice row in the report's `invoices` array based on the changes in the CSRD article rows.
 * - It calculates the new sum for the invoice and updates the main invoice fields like `priceExcMoms`, `priceIncMoms`, `customerName`, etc.
 */
    UpdateMainInvoiceWhenChangeOccursOnCsrdArticleRows:(report:StandardInvoiceReport,csrdRow:InternalInvoiceWithCsrdAndGroupId/*InvoicesWithCsrdAndGroupId*/,customers:Customer[])=>{
       const buff:StandardInvoiceReport = structuredClone(report)
       let customerOrgId = '';
       let headId:number = -1;
       let matched = false;
      buff.report.csrdGroup =  buff.report.csrdGroup?.map((x:/*InvoicesWithCsrdAndGroupId*/InternalInvoiceWithCsrdAndGroupId) => {
        if(x.groupId == csrdRow.groupId){
           // oldInvoiceId = x.invoiceNumber
           customerOrgId = csrdRow.customerOrgId
            x.invoiceNumber = csrdRow.invoiceNumber
            x.billingDate = csrdRow.billingDate
            x.customerName = csrdRow.customerName
            x.customerOrgId = csrdRow.customerOrgId
            x.contractId = csrdRow.contractId
            if(!matched){
                headId = x.csrdConnectionId
                matched = true
            }
            return x
        }
        return x

       })

      const newInvoiceSum = buff.report.csrdGroup?.reduce((acc,curr) => {
        if(curr.invoiceNumber == csrdRow.invoiceNumber){

            return acc + curr.rowSumExclMoms
        }
        return acc
       },0) 
       const customerId = customers.find(x => x.kndOrgnr == +customerOrgId)
       
       const foundIndexForInvoice = buff.report.invoices?.find(x => 
        x.csrdConnectionId == headId)
       
       if(typeof foundIndexForInvoice !== 'undefined' && typeof newInvoiceSum !== 'undefined' && typeof customerId !== 'undefined'){ 
          foundIndexForInvoice.priceExcMoms = newInvoiceSum
          foundIndexForInvoice.priceIncMoms = newInvoiceSum * 0.25 +newInvoiceSum
          foundIndexForInvoice.contractId = csrdRow.contractId
          foundIndexForInvoice.customerName = csrdRow.customerName
          foundIndexForInvoice.customerOrgId = csrdRow.customerOrgId
          foundIndexForInvoice.billingDate = csrdRow.billingDate
          foundIndexForInvoice.invoiceNumber = csrdRow.invoiceNumber
          foundIndexForInvoice.dueDate = csrdRow.billingDate
          foundIndexForInvoice.sendDate = csrdRow.billingDate
          foundIndexForInvoice.customerId = customerId?.kndLopnr.toString()       
       }
       return buff
    },
    CheckInvoiceDateForReports:(periods:{[key:string]:ReportedPeriodReportType[]},period:string) => {
    
     
    },
    /**
 * Converts a given Date object into a period string formatted as 'yyyy-MM'.
 * 
 * @param {Date} dateToConvert - The date to be converted to a period string.
 * @returns {string} - A string representing the date in the format 'yyyy-MM' (Swedish locale).
 */
    ConvertDateToPeriodString:(dateToConvert:Date)=>{
        return dateToConvert.toLocaleDateString('sv-SE',{year:'numeric',month:'2-digit'});
    },
    /**
 * Manages the addition, removal, or replacement of a `MovedDateInvoice` in the provided array
 * based on the action specified in the item.
 * 
 * @param {MovedDateInvoice[]} data - The array of current `MovedDateInvoice` items.
 * @param {MovedDateInvoice} item - The `MovedDateInvoice` item to be added, replaced, or removed.
 * @returns {MovedDateInvoice[]} - A new array with the updated set of `MovedDateInvoice` items.
 * 
 * @remarks
 * The `item.action` determines what happens:
 * - `'PUSH'`: If the item is not already in the array, it is added. If it's already present, it is removed and then re-added.
 * - `'POP'`: If the item is found, it is removed from the array.
 */
    ManageDateActions:(data:MovedDateInvoice[],item:MovedDateInvoice)=>{
        const buffForCurrState = structuredClone(data);
        const buffForItemPassed = structuredClone(item);
        const res =  buffForCurrState.findIndex((x:MovedDateInvoice) => x.id == item.id);
        if(res == -1 && item.action == 'PUSH'){
            buffForCurrState.push(buffForItemPassed);
        }
        else if(res > -1 && item.action == 'PUSH'){
            buffForCurrState.splice(res,1);
            buffForCurrState.push(buffForItemPassed);
        }
        else if(res > -1 && item.action == 'POP'){
            buffForCurrState.splice(res, 1);
        }
        return buffForCurrState;
    }

    
    
}
export{
    editUtils
}